<template>
  <div class="details__actions">
    <a @click.prevent="handleClick">
      <v-icon>keyboard_arrow_left</v-icon> {{ $t(`${namespace}.goBack`) }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'Actions',
  data () {
    return {
      namespace: 'Views.NewWebCallPage.rideList.details.actions'
    }
  },
  methods: {
    handleClick () {
      this.$emit('handleDetailsToggle')
    }
  }
}
</script>

<style lang="scss" scoped>
.details__actions {
  display: flex;
  flex-direction: row;
  padding-bottom: 12px;

  a {
    align-items: center;
    color: $gray-6;
    display: flex;
    font-size: 12px;
    line-height: normal;
  }
}
</style>
